import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

const Thumbnails = ({ data, activeType, handleClick, isActive, filter }) => {
  return (
    <Root>
      <LabelWrapper>
        <h4>View Homes</h4>
      </LabelWrapper>
      <Content key={isActive}>
        {Object.values(data).map((floorplan, index) => {
          if (activeType === 0 && !floorplan.id.includes('TH')) {
            return (
              <Thumbnail
                soldout={floorplan.soldout}
                key={index}
                onClick={() => handleClick(floorplan.id)}
                active={
                  (activeType === 0 && filter === floorplan.bed) ||
                  (activeType === 0 && filter === 4) ||
                  (activeType === 1 && filter === 0 && floorplan.bed === 3) ||
                  (activeType === 1 &&
                    filter === 1 &&
                    floorplan.bed === 3 &&
                    floorplan.flex) ||
                  (activeType === 1 &&
                    filter === 2 &&
                    floorplan.bed === 3 &&
                    floorplan.family) ||
                  (activeType === 1 && filter === 3)
                }
              >
                <img
                  src={require(`src/assets/images/floorplans/thumbnails/${floorplan.img}.png`)}
                  alt={floorplan.id}
                />
                {floorplan.soldout && (
                  <Overlay>
                    <img
                      src={require('src/assets/images/floorplans/sold_out.svg')}
                      alt="sold out"
                    />
                  </Overlay>
                )}
              </Thumbnail>
            );
          } else if (activeType === 1 && floorplan.id.includes('TH')) {
            return (
              <Thumbnail
                soldout={floorplan.soldout}
                key={index}
                onClick={() => handleClick(floorplan.id)}
                active={
                  (activeType === 0 && filter === floorplan.bed) ||
                  (activeType === 0 && filter === 4) ||
                  (activeType === 1 && filter === 0 && floorplan.bed === 3) ||
                  (activeType === 1 &&
                    filter === 1 &&
                    floorplan.bed === 3 &&
                    floorplan.flex) ||
                  (activeType === 1 &&
                    filter === 2 &&
                    floorplan.bed === 3 &&
                    floorplan.family) ||
                  (activeType === 1 && filter === 3)
                }
              >
                <img
                  src={require(`src/assets/images/floorplans/thumbnails/${floorplan.img}.png`)}
                  alt={floorplan.id}
                />
                {floorplan.soldout && (
                  <Overlay>
                    <img
                      src={require('src/assets/images/floorplans/sold_out.svg')}
                      alt="sold out"
                    />
                  </Overlay>
                )}
              </Thumbnail>
            );
          } else {
            return null;
          }
        })}
      </Content>
    </Root>
  );
};

export default Thumbnails;

Thumbnails.propTypes = {
  data: PropTypes.object,
  activeType: PropTypes.number,
  handleClick: PropTypes.func,
  isActive: PropTypes.number,
};

const Root = styled.div`
  width: 100%;
  height: 715px;
  background-color: #f5f5fa;
  position: relative;
  padding-bottom: 20px;
  @media (min-width: ${media.mdup}) {
    width: 55%;
    margin-left: 10%;
    padding: 20px 10px;
    border-top: 10px solid ${({ theme }) => theme.colorDarkBlue};
  }
`;

const animateShow = keyframes`
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow: scroll;
  height: 90%;
  padding: 0 10px;
  animation: ${animateShow} 0.4s ease-out forwards;
  @media (min-width: ${media.mdup}) {
    height: auto;
    max-height: 100%;
    justify-content: flex-start;
    ::-webkit-scrollbar {
      width: 7px;
    }
    ::-webkit-scrollbar-thumb {
      height: 6px;
      display: block;
      border-radius: 4px;
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
    }
    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;

const LabelWrapper = styled.div`
  background: #0b1a27;
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 30px;
  position: relative;
  margin-bottom: 20px;
  @media (min-width: ${media.mdup}) {
    display: none;
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: #ff7802;
  }

  h4 {
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 16px;
    font-weight: 500;
    color: #ff7802;
    letter-spacing: 0;
    text-transform: uppercase;
  }
`;

const Thumbnail = styled.div`
  position: relative;
  cursor: pointer;
  display: ${(props) => (props.active ? 'block' : 'none')};
  transition: 0.4s ease-in-out;
  max-width: 50%;
  img {
    max-width: 100%;
    width: auto;
    height: auto;
  }
  @media (min-width: ${media.xsup}) {
    width: 33.33%;
  }
  @media (min-width: ${media.mdup}) {
    margin: 0.5%;
    width: 32.33%;
    min-height: 250px;
    img {
      image-rendering: -webkit-optimize-contrast;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(247, 247, 247, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 50%;
    height: auto;
    position: absolute;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Floorplans/elements/Thumbnails.js